import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/guide-how-to-plan-a-wedding";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/guides/how-to-plan-a-wedding")({
  head: SEO["/guides/how-to-plan-a-wedding"],
  component: () => <ContentPage path="/guides/how-to-plan-a-wedding" body={body} />,
});
